module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.1169/img/pumpkin.svg"